module.exports = __webpack_public_path__ + "40231cd24f2217eb9f02d81821924d23.png";